import { Center, Heading } from "@chakra-ui/react";
import React from "react";

const NotFound = () => {
  return (
    <Center>
      <Heading mt="12">Page Not Found</Heading>
    </Center>
  );
};

export default NotFound;
